
/**
 * TicketCheckReport.js
 * 用于解析和转换销售数据为表格数据结构
 */

// 全局变量，存储价格列表和员工映射
var priceList = [] // 价格列表，包含priceId、productName、crowdtypeName等信息
var checkstationMap = [] // 员工映射，包含staffId和staffName等信息

/**
 * 解析表格数据
 * @param {Object} apiReturnData - API返回的数据，包含priceList、saleList、refundList等字段
 * @param {Array} checkstationList - 售票站点列表，包含checkstationId和checkstationName等信息
 * @returns {Array} - 转换后的表格数据结构
 */
export const parseTableData = (apiReturnData) => {
    priceList = apiReturnData.priceList
    checkstationMap = apiReturnData.checkstationList
    checkstationMap.push({checkstationId: 0, checkstationName: '其他'})
    const ticketList = apiReturnData.ticketList
    // const refundList = apiReturnData.refundList
    
    let paramData = []
    for(let item of ticketList){
        let param = paramData.find(param => param.date == item.createDay)
        if(param){
            param.productList = parseProductList(param.productList, item)

        }else{
            param = {
                date: item.createDay,
                productList: parseProductList([], item),
            }
            paramData.push(param)
        }
    }
    // for(let item of refundList){
    //     let param = paramData.find(param => param.date == item.createDay)
    //     if(param){
    //         param.productList = parseProductList(param.productList, item)

    //     }else{
    //         param = {
    //             date: item.createDay,
    //             productList: parseProductList([], item),
    //         }
    //         paramData.push(param)
    //     }
    // }
    let totalParamData = {
        date: '总计',
        productList: [],
    }
    for(let item of ticketList){    
        totalParamData.productList = parseProductList(totalParamData.productList, item)
    }
    // for(let item of refundList){
    //     totalParamData.productList = parseProductList(totalParamData.productList, item)
    // }
    paramData.push(totalParamData)
    return createTableData(paramData)
}

/**
 * 解析产品列表
 * @param {Array} productList - 产品列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的产品列表
 */
export const parseProductList = (productList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let productParam = productList.find(product => product.productName == price.productName)
    if(productParam){
        productParam.priceList = parsePriceList(productParam.priceList, item)
    }else{
        const priceData = parsePriceList([], item)
        productParam = {
            productName: price.productName,
            priceList: priceData,
        }
        productList.push(productParam)
    }
    return productList
}

/**
 * 解析价格列表
 * @param {Array} priceData - 价格列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的价格列表
 */
export const parsePriceList = (priceData, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let priceParam = priceData.find(priceData => priceData.crowdtypeName == price.crowdtypeName)
    if(priceParam){
        priceParam.salePrice = parseSalePrice(priceParam.salePrice, item)
    }else{
        const salePrice = parseSalePrice([], item)
        priceParam = {
            crowdtypeName: price.crowdtypeName,
            salePrice: salePrice,
        }
        priceData.push(priceParam)
    }
    return priceData
}

/**
 * 解析销售价格列表
 * @param {Array} salePriceList - 销售价格列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的销售价格列表
 */
export const parseSalePrice = (salePriceList, item) => {
    let salePriceParam = salePriceList.find(price => price.price == item.settlementPrice)
    if(salePriceParam){
        salePriceParam.checkstationList = parseCheckstationList(salePriceParam.checkstationList, item)
    }else{
        const checkstationList = parseCheckstationList([], item)
        salePriceParam = {
            price: item.settlementPrice,
            checkstationList: checkstationList,
        }
        salePriceList.push(salePriceParam)
    }
    return salePriceList
}

/**
 * 解析检查设备列表
 * @param {Array} checkstationId - 检查设备列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的检查设备列表
 */
export const parseCheckstationList = (checkstationList, item) => {
    const checkstation = checkstationMap.find(checkstation => checkstation.checkstationId == item.stationId)
    let checkstationParam = checkstationList.find(checkstationitem => checkstationitem.checkstationId == checkstation.checkstationName)
    if(checkstationParam){
        checkstationParam = parseQuantity(checkstationParam, item)
    }else{
        checkstationParam = parseQuantity(null, item)
        checkstationList.push(checkstationParam)
    }
    return checkstationList
}

/**
 * 解析数量信息
 * @param {Object} checkdevice - 检查设备对象
 * @param {Object} item - 销售或退款数据项
 * @returns {Object} - 更新后的检查设备对象
 */
export const parseQuantity = (checkdevice, item) => {
    let checkdeviceParam = checkdevice
    if(checkdeviceParam == null){
        const checkstationMapItem = checkstationMap.find(checkstation => checkstation.checkstationId == item.stationId)
        checkdeviceParam = {
            checkstationId: checkstationMapItem.checkstationName,
            quantity: 0,
            operateQuantity: 0,
            sealQuantity: 0,
            smallCount: 0,
            payCount: 0,
        }
    }
    // if(item.operateQuantity && item.operateQuantity > 0){
    //     checkdeviceParam.operateQuantity = checkdeviceParam.operateQuantity + item.operateQuantity
    //     checkdeviceParam.sealQuantity = checkdeviceParam.sealQuantity - item.operateQuantity
    //     checkdeviceParam.smallCount = checkdeviceParam.smallCount - (item.operateQuantity * item.salePrice)
    //     checkdeviceParam.payCount = checkdeviceParam.payCount - (item.operateQuantity * item.salePrice)
    // }
    // console.log(item)
    switch(item.operateType){
        case 4:
            checkdeviceParam.quantity = checkdeviceParam.quantity + item.operateQuantity
            checkdeviceParam.sealQuantity = checkdeviceParam.sealQuantity + item.operateQuantity
            checkdeviceParam.smallCount = checkdeviceParam.smallCount + (item.operateQuantity * item.settlementPrice)
            checkdeviceParam.payCount = checkdeviceParam.payCount + (item.operateQuantity * item.settlementPrice)
            break;
        case 5:
            checkdeviceParam.quantity = checkdeviceParam.quantity - item.operateQuantity
            checkdeviceParam.sealQuantity = checkdeviceParam.sealQuantity - item.operateQuantity
            checkdeviceParam.smallCount = checkdeviceParam.smallCount - (item.operateQuantity * item.settlementPrice)
            checkdeviceParam.payCount = checkdeviceParam.payCount - (item.operateQuantity * item.settlementPrice)
            break;
        case 6:
            checkdeviceParam.operateQuantity = checkdeviceParam.operateQuantity + item.operateQuantity
            checkdeviceParam.sealQuantity = checkdeviceParam.sealQuantity - item.operateQuantity
            checkdeviceParam.smallCount = checkdeviceParam.smallCount - (item.operateQuantity * item.settlementPrice)
            checkdeviceParam.payCount = checkdeviceParam.payCount - (item.operateQuantity * item.settlementPrice)
            break;
    }
    return checkdeviceParam
}

/**
 * 创建表格数据结构
 * @param {Array} paramData - 按日期分组的数据
 * @returns {Array} - 转换后的表格数据结构
 */
export const createTableData = (paramData) => {
    let tableData = []
    let i = 1
    for(let param of paramData){
        let productRow = []
        let bigQuantity = 0
        let bigOperateQuantity = 0
        let bigSealQuantity = 0
        let bigSmallCount = 0
        let bigPayCount = 0
        for(let product of param.productList){
            let priceRow = []
            
            for(let price of product.priceList){
                let salePriceList = []
                for(let salePrice of price.salePrice){
                    let checkstationList = []
                    let smallQuantity = 0
                    let smallOperateQuantity = 0
                    let smallSealQuantity = 0
                    let smallSmallCount = 0
                    let smallPayCount = 0
                    for(let checkstation of salePrice.checkstationList){
                        let tr = [
                            { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: product.productName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: price.crowdtypeName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: salePrice.price/100, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: checkstation.checkstationId, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: checkstation.quantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: checkstation.operateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: checkstation.sealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: checkstation.payCount/100, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                        ]
                        checkstationList.push({ tr: tr })
                        smallQuantity = smallQuantity + checkstation.quantity
                        smallOperateQuantity = smallOperateQuantity + checkstation.operateQuantity
                        smallSealQuantity = smallSealQuantity + checkstation.sealQuantity
                        smallSmallCount = smallSmallCount + checkstation.smallCount
                        smallPayCount = smallPayCount + checkstation.payCount
                        bigQuantity = bigQuantity + checkstation.quantity
                        bigOperateQuantity = bigOperateQuantity + checkstation.operateQuantity
                        bigSealQuantity = bigSealQuantity + checkstation.sealQuantity
                        bigSmallCount = bigSmallCount + checkstation.smallCount
                        bigPayCount = bigPayCount + checkstation.payCount
                    }
                    
                    checkstationList[0].tr[3].rowspan = checkstationList.length
                    checkstationList[0].tr[3].colspan = 1
                    salePriceList.push(...checkstationList)
                    let tr = [
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '小计', colspan: 2, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: smallQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                    ]
                    salePriceList.push({ tr: tr })
                }
                
                
                salePriceList[0].tr[2].rowspan = salePriceList.length
                salePriceList[0].tr[2].colspan = 1
                priceRow.push(...salePriceList)
                
            }
            
            priceRow[0].tr[1].rowspan = priceRow.length
            priceRow[0].tr[1].colspan = 1
            productRow.push(...priceRow)
        }
        let tr = [
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: '合计', colspan: 4, rowspan: 1, class: 'qa-td-total' },
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: bigQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-total' },
        ]
        productRow.push({ tr: tr })
        productRow[0].tr[0].rowspan = productRow.length
        productRow[0].tr[0].colspan = 1
        if(i == paramData.length){
            productRow[0].tr[0].class = 'qa-td-merged qa-th-merged'
        }
        tableData.push(...productRow)
        i++
    }
    return tableData
}